import { Link } from 'react-router-dom'
import TypeIcon from 'components/misc/TypeIcon'
import styles from './styles/HorizontalTally.css'
import Tooltip from './Tooltip'
import classNames from 'classnames'

const tooltipContent = (type, entityType, directionality) => {
  switch (type) {
    case 'publications':
      return `Number of publications citing this ${entityType}`
    case 'cited-publications':
      return `Number of times this ${entityType} was cited`
    case 'supporting':
      return `Number of supporting citation statements ${directionality === 'target' ? 'about this' : 'given by this'} ${entityType}`
    case 'mentioning':
      return `Number of mentioning citation statements ${directionality === 'target' ? 'about this' : 'given by this'} ${entityType}`
    case 'contradicting':
      return `Number of contrasting citation statements ${directionality === 'target' ? 'about this' : 'given by this'} ${entityType}`
    case 'retracted':
      return 'Number of notices of retraction or withdrawl'
    case 'notices':
      return 'Number of editorial notices such as corrections'
    default:
      return ''
  }
}

const iconType = (type) => {
  // if we have the cited-publications type then the icon type is just publications.
  return type === 'cited-publications' ? 'publications' : type
}

const Column = ({ type, count, entityType, directionality }) => (
  <div className={styles.column}>
    <Tooltip
      content={(
        <>
          {tooltipContent(type, entityType, directionality)}
          <br />
          Click here to read the citation statements.
        </>)}
    >
      <TypeIcon type={iconType(type)} />
      <span className={styles.count}>{count?.toLocaleString() || 0}</span>
    </Tooltip>
  </div>
)

const noticesFilter = ({ status }) => {
  for (const retractedLemma of CONFIG.retractionLemmas) {
    if (status.toLowerCase().includes(retractedLemma)) {
      return false
    }
  }
  return true
}

const retractionFilter = ({ status }) => {
  for (const retractedLemma of CONFIG.retractionLemmas) {
    if (status.toLowerCase().includes(retractedLemma)) {
      return true
    }
  }
  return false
}

export const HorizontalTally = ({
  tally,
  notices = [],
  link,
  showPubTally = true,
  showCitingPubTally = false,
  entityType = 'work',
  directionality = 'target',
  clickable = false
}) => (
  <Link
    className={classNames(styles.horizontalTally, {
      [styles.notClickable]: !link && !clickable
    })}
    to={link || ''}
    target='_blank'
    disabled={!link}
  >
    <div className={styles.inner}>
      {showPubTally ? <Column entityType={entityType} type='publications' count={tally?.citingPublications} /> : null}
      {showCitingPubTally ? <Column entityType={entityType} type='cited-publications' count={tally?.numCitedPublications} /> : null}
      <Column entityType={entityType} directionality={directionality} type='supporting' count={tally?.supporting || 0} />
      <Column entityType={entityType} directionality={directionality} type='mentioning' count={tally?.mentioning || 0} />
      <Column entityType={entityType} directionality={directionality} type='contradicting' count={(tally?.contradicting || tally?.contrasting) || 0} />
      {notices && notices.filter(retractionFilter).length > 0 && <Column entityType={entityType} type='retracted' count={`${notices?.filter(retractionFilter).length || 0}`} />}
      {notices && notices.filter(noticesFilter).length > 0 && <Column entityType={entityType} type='notices' count={`${notices?.filter(noticesFilter).length || 0}`} />}
    </div>
  </Link>
)

export default HorizontalTally
